/**
 * @typedef {'memo' | 'smartData' | 'null' | 'label' | 'highPriorityLabel'} AddressBadgeType
 */

/**
 * @type {Record<string, AddressBadgeType>}
 */
export const addressBadgeType = {
  MEMO: 'memo',
  SMART_DATA: 'smartData',
  NULL: 'null',
  LABEL: 'label',
  HIGH_PRIORITY_LABEL: 'highPriorityLabel',
};

export const addressBadgeColorMapping = {
  [addressBadgeType.MEMO]: 'secondary',
  [addressBadgeType.SMART_DATA]: 'primary',
  [addressBadgeType.NULL]: 'dark',
  [addressBadgeType.LABEL]: 'info',
  [addressBadgeType.HIGH_PRIORITY_LABEL]: 'success',
};

export const SOURCE_CATEGORIES = {
  ON_CHAIN: 'On-Chain Data',
  CROWD_SOURCE: 'Crowdsource',
  GOVERNMENT: 'Government Source',
  BLOCKSCOPE_VERIFIED: 'Blockscope Verified',
  SMART_INFERENCE: 'Smart Inference',
  BLOCKSCOPE_RESEARCH: 'Blockscope Research',
};

export const labelCategoryIcon = {
  [SOURCE_CATEGORIES.ON_CHAIN]: 'link',
  [SOURCE_CATEGORIES.CROWD_SOURCE]: 'user-tag',
  [SOURCE_CATEGORIES.GOVERNMENT]: 'building-columns',
  [SOURCE_CATEGORIES.BLOCKSCOPE_VERIFIED]: 'circle-check',
  [SOURCE_CATEGORIES.SMART_INFERENCE]: 'wand-magic-sparkles',
  [SOURCE_CATEGORIES.BLOCKSCOPE_RESEARCH]: 'magnifying-glass',
};

export const LABEL_ACP_FORM_SOURCE_CATEGORIES = [
  { label: SOURCE_CATEGORIES.ON_CHAIN, value: SOURCE_CATEGORIES.ON_CHAIN },
  {
    label: SOURCE_CATEGORIES.CROWD_SOURCE,
    value: SOURCE_CATEGORIES.CROWD_SOURCE,
  },
  { label: SOURCE_CATEGORIES.GOVERNMENT, value: SOURCE_CATEGORIES.GOVERNMENT },
  {
    label: SOURCE_CATEGORIES.SMART_INFERENCE,
    value: SOURCE_CATEGORIES.SMART_INFERENCE,
  },
  {
    label: SOURCE_CATEGORIES.BLOCKSCOPE_VERIFIED,
    value: SOURCE_CATEGORIES.BLOCKSCOPE_VERIFIED,
  },
  {
    label: SOURCE_CATEGORIES.BLOCKSCOPE_RESEARCH,
    value: SOURCE_CATEGORIES.BLOCKSCOPE_RESEARCH,
  },
];

export const orderLabels = (knownLabels) => {
  const badgeList = [];
  // Create a copy of knownLabels before sorting
  const sortedLabels = [...knownLabels].sort((a, b) => a.priority - b.priority);

  sortedLabels.forEach((label) => {
    if ((label.label ?? label.sourceAlias) !== 'Contract') {
      badgeList.push({
        text: `${label.label ?? label.sourceAlias}` || '',
        type:
          label.priority < 10
            ? addressBadgeType.HIGH_PRIORITY_LABEL
            : addressBadgeType.LABEL,
        labelType: label.type,
        priority: label.priority,
        sourceCategory: label.sourceCategory,
        logo: label.logo,
      });
    }
  });

  return badgeList;
};
